import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MaintenanceService } from '../maintenance.service';

/**
 * Detects the 503 maintenance response returned by the APIs and switches the app into maintenance mode,
 * which replaces the whole app with the maintenance page.
 */
@Injectable({
  providedIn: 'root',
})
export class MaintenanceInterceptor implements HttpInterceptor {
  private readonly maintenanceService = inject(MaintenanceService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (MaintenanceService.isMaintenanceResponse(error)) {
          this.maintenanceService.enterMaintenance(error.error.message);
        }
        return throwError(() => error);
      }),
    );
  }
}
